import { ImportWizardProvider } from '../../../features/members-import/state';
import { ImportWizard } from '../components';

/** `members/import`: the "Add members from a file" wizard. Its state lives while this route is mounted. */
function MembersImportPage() {
  return (
    <ImportWizardProvider>
      <ImportWizard />
    </ImportWizardProvider>
  );
}

export default MembersImportPage;
